/**
 * @fileoverview Boter Kaas en Eieren Board Component
 * @description Main game board with 3x3 grid of cells
 */

import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import { TicTacToeBoardProps, BoardPosition } from "../types";
import { TicTacToeCell } from "./TicTacToeCell";

const BOARD_SIZE = Math.min(Dimensions.get("window").width - 48, 350);

/**
 * TicTacToeBoard - The main 3x3 game board
 */
export const TicTacToeBoard: React.FC<TicTacToeBoardProps> = ({
  board,
  disabled,
  winLine,
  onCellPress,
  isMyTurn,
  animatingCell,
}) => {
  /**
   * Check if a position is part of the winning line
   */
  const isWinningCell = (position: BoardPosition): boolean => {
    if (!winLine) return false;
    return winLine.positions.includes(position);
  };

  /**
   * Render cells
   */
  const renderCells = () => {
    return board.map((value, index) => {
      const position = index as BoardPosition;
      return (
        <TicTacToeCell
          key={position}
          value={value}
          position={position}
          disabled={disabled || !isMyTurn}
          isWinningCell={isWinningCell(position)}
          onPress={() => onCellPress(position)}
          isAnimating={animatingCell === position}
        />
      );
    });
  };

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.board,
          { width: BOARD_SIZE, height: BOARD_SIZE },
          disabled && styles.boardDisabled,
        ]}
      >
        {renderCells()}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
  board: {
    flexDirection: "row",
    flexWrap: "wrap",
    backgroundColor: "#1F2937",
    borderRadius: 16,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  boardDisabled: {
    opacity: 0.7,
  },
});

export default TicTacToeBoard;

